import React, { useState } from 'react';
import connect from "react-redux/es/connect/connect";

import { NavLink } from 'react-router-dom';
import { withRoutingContext } from "./../RoutingContext";
import ExternalLink from "../widgets/ExternalLink";

import {ReactComponent as NetAppLogo} from "ui-components/src/images/netapp-services/netapp-header-logo-blue.svg";
import { FixedLeftNav } from "ui-components";

import { servicesMap } from '../../consts/sevicesMap';
import {ReactComponent as FabricViewIcon} from "ui-components/src/images/nav-icons/ic-fabric-view.svg";
import {ReactComponent as ProductsIcon} from "ui-components/src/images/nav-icons/ic-products.svg";
import {ReactComponent as ToolsIcon} from "ui-components/src/images/nav-icons/ic-tools.svg";
import {ReactComponent as InternalIcon} from "ui-components/src/images/nav-icons/ic-internal.svg";
import {ReactComponent as DeveloperHubIcon} from "ui-components/src/images/nav-icons/ic-api.svg";
import {ReactComponent as FeatureSpotlightIcon} from "ui-components/src/images/nav-icons/ic-news.svg";
import {ReactComponent as ServicesStatusesIcon} from "ui-components/src/images/nav-icons/ic-status.svg";
import {ReactComponent as PartnersIcon} from "ui-components/src/images/nav-icons/ic-partners.svg";
import {ReactComponent as ContactUsIcon} from "ui-components/src/images/nav-icons/ic-contact.svg";
import {ReactComponent as TimelineIcon} from "ui-components/src/images/nav-icons/ic-timeline.svg";
import {ReactComponent as ExternalLinkIcon} from "ui-components/src/images/monochrome-icons/ic-link.svg";
import {ReactComponent as ArrowIcon} from "ui-components/src/images/monochrome-icons/ic-menu-arrow.svg";

import ContactUsModal from "./../dialog/ContactUsModal";

const ONTAPCloudLogo = servicesMap["cloud-volumes-ontap"].logo;
const CloudVolumesLogo = servicesMap["cloud-volumes-service"].logo;
const CloudSyncLogo = servicesMap["cloud-sync"].logo;
const CloudBackupLogo = servicesMap["cloud-backup-service"].logo;
const OCILogo = servicesMap["cloud-insights"].logo;
const CloudTieringLogo = servicesMap["cloud-tiering"].logo;
const SaaSBackupLogo = servicesMap["saas-backup"].logo;

const mapStateToProps = (state) => {
    return {
        activeFeatures: state.features.active,
        auth: state.auth
    };
};

const products = [
    {Icon: ONTAPCloudLogo, title: "Cloud Volumes ONTAP", href: "/dashboard/cloud-volumes-ontap"},
    {Icon: CloudVolumesLogo, title: "Cloud Volumes Service", href: "/dashboard/cloud-volumes-service"},
    {Icon: OCILogo, title: "Cloud Insights", href: "/dashboard/cloud-insights"},
    {Icon: CloudSyncLogo, title: "Cloud Sync", href: "/dashboard/cloud-sync"},
    {Icon: SaaSBackupLogo, title: "SaaS Backup", href: "/dashboard/saas-backup"},
    {Icon: CloudTieringLogo, title: "Cloud Tiering", href: "/dashboard/cloud-tiering"},
    {Icon: CloudBackupLogo, title: "Cloud Backup Service", href: "/dashboard/cloud-backup-service"}
];

const tools = [
    {title: "Cloud Assessment", href: "/cloud-assessment"},
    {isExternalLink: true, title: "TCO Azure Calculator", linkKey: "mainNav.azureTcoCalculator"},
    {isExternalLink: true, title: "TCO AWS Calculator", linkKey: "mainNav.awsTcoCalculator"},
    {isExternalLink: true, title: "TCO GC Calculator", linkKey: "mainNav.gcpTcoCalculator"},
];

const HeaderButton = () => <ExternalLink title="NetApp logo" linkKey="marketingPageRedirect"><NetAppLogo/></ExternalLink>;

const NavWrapperDumb = ({activeFeatures, auth}) => {
    const [contactUsDialogParent, setContactUsDialogParent] = useState(null);

    const mainLinks = [
        {requiresAuth: true, href: "/fabric-view", Icon: FabricViewIcon, title: "Fabric View"},
        {requiresAuth: true, href: "/feature-spotlight", Icon: FeatureSpotlightIcon, title: "Feature Spotlight"},
        {requiresAuth: true, isDropdown: true, Icon: ProductsIcon, title: "Products", links: products},
        {requiresAuth: true, isDropdown: true, Icon: ToolsIcon, title: "Tools", links: tools},
        {requiresFeatureFlag: "timeline", requiresAuth: true, href: "/audit", isDropdown: false, Icon: TimelineIcon, title: "Timeline"},
        {requiresAuth: true, onlyShowInternal: true, href: "/netapp-internal", Icon: InternalIcon, title: "NetApp Internal"},
        {href: "/developer-hub", Icon: DeveloperHubIcon, title: "API"},
        {requiresAuth: true, href: "/partner-center", Icon: PartnersIcon, title: "Cloud First Partners"},
        {isExternalLink: true, linkKey: "mainNav.statusPage", Icon: ServicesStatusesIcon, title: "Services Status"},
        {isAction: true, Icon: ContactUsIcon, title: "Contact Us", onClick: (el) => setContactUsDialogParent(el.target)}
    ];

    return <React.Fragment>
        {contactUsDialogParent && <ContactUsModal target={contactUsDialogParent} closeTrigger={() => setContactUsDialogParent(null)}/>}
        <FixedLeftNav ArrowIcon={ArrowIcon} ExternalLinkIcon={ExternalLinkIcon} HeaderButton={HeaderButton} InternalLink={NavLink} ExternalLink={ExternalLink} mainLinks={mainLinks.filter(link => {
            if(link.requiresAuth && !auth.authenticated) {
                return false;
            }

            if(link.onlyShowInternal && !auth.isNetAppInternal) {
                return false
            }

            if (link.requiresFeatureFlag && !activeFeatures[link.requiresFeatureFlag]) {
                return false
            }

            return true;
        })}/>
    </React.Fragment>
};

export default withRoutingContext(connect(mapStateToProps)(NavWrapperDumb));